/* eslint-disable semi,semi-style */
import React, { FunctionComponent } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { useRequest } from 'ahooks';
import { Spin } from 'antd';
import request from '@/util/request';
import Header, { UserInfo, UserInfoContext } from './components/header/index';
import Loader from './components/Loader';
import Index from './components/Index';
import Tools from './components/tools';
import platforms from './config';
import { login } from '../../util/login';
import './index.scss';
import './antd.less';
import { getUserInfoInOperate } from '../index/service';

interface AppProps {}

const App: FunctionComponent<AppProps> = () => {
  const { data, loading, error } = useRequest(getUserInfoInOperate);
  console.log('In operate', { data, loading, error });
  let userInfo = undefined;
  if (data) {
    userInfo = Object.assign(
      {
        loginError: false,
      },
      data,
    );
  } else if (error) {
    userInfo = Object.assign(
      {},
      {
        loginError: true,
      },
    );
  }
  window.Login = login;
  window.loginInfo = userInfo;
  window.loginPending = loading;
  return (
    <Spin spinning={loading}>
      <UserInfoContext.Provider value={userInfo}>
        <Router>
          <Header user={data} />
          <Switch>
            <Route path="/" exact component={Index} />
            {platforms.map((item, key) => (
              <Route key={key} path={item.path} exact={!!item.exact} render={() => <Loader source={item} />} />
            ))}
          </Switch>
        </Router>
      </UserInfoContext.Provider>
    </Spin>
  );
};

export default App
